
import './App.css';
import Home from './view/Home';

function App() {
  return (
    <div>
      <Home/>
    </div>
  );
}

export default App;
